module.exports = __webpack_public_path__ + "img/js.d191a94f.png";